import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const names = ['Juan M.', 'Lucas P.', 'Matias G.', 'Federico R.', 'Santiago L.', 'Agustin C.', 'Nicolas B.', 'Tomas S.', 'Martin V.', 'Ignacio D.'];
const cities = ['CABA', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 59) + 1;
      setBuyer({
        name: randomName,
        city: randomCity,
        time: `${randomTime} min`
      });
      setVisible(true);
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showPopup, 10000);
    const interval = setInterval(() => {
      if (!visible) {
        setTimeout(showPopup, Math.random() * 15000 + 15000);
      }
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [visible]);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 z-50 bg-white border border-blue-100 shadow-xl rounded-lg p-3 flex items-start gap-3 max-w-xs animate-in slide-in-from-bottom-5 fade-in duration-300" data-id="element-128">
      <div className="bg-blue-100 p-2 rounded-full flex-shrink-0" data-id="element-129">
        <CheckCircle className="w-5 h-5 text-blue-600" data-id="element-130" />
      </div>
      <div data-id="element-131">
        <p className="text-sm text-slate-800 font-medium" data-id="element-132">
          <span className="font-bold" data-id="element-133">{buyer.name}</span> de {buyer.city}
        </p>
        <p className="text-xs text-slate-500 mt-0.5" data-id="element-134">
          Compró Handball Coach Pro hace {buyer.time}
        </p>
      </div>
    </div>;
}